import AnimatedNumber from 'animated-number-react';
import * as React from 'react';
import {useState} from 'react';

export default function AnimatedCoins({currentBalance}) {
  const [duration, setDuration] = useState(1000)
  const formatValue = (value) => value.toFixed(0);

  return (
    <div>
      <AnimatedNumber
        value={currentBalance}
        formatValue={formatValue}
        duration={duration}
      />
    </div>
  );
}